import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FileItem, FileLikeObject, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { friendlyMemorySize } from '../../utils/friendly-memory-size';

@Component({
  selector: 'ad-upload-area',
  templateUrl: './ad-upload-area.component.html',
  styleUrls: ['./ad-upload-area.component.scss'],
})
export class AdUploadAreaComponent implements OnInit, OnDestroy {
  @ContentChild(TemplateRef, { static: true }) content: TemplateRef<any>;
  @ViewChild('fileSelect', { static: false })
  selectDir: ElementRef<HTMLInputElement>;
  @Input() url: string = '';
  @Input() displaySelectBtn: boolean = true;
  @Input() selectBtnText: string = 'Choose File';
  @Input() multiple: boolean = false;
  @Input() autoUpload: boolean = true;
  @Input() allowedFileTypes: string[];
  @Input() allowedMimeTypes: string[];
  @Input() maxFileSize: number = 20971520;
  @Output() onAddingFileFailed: EventEmitter<
    { item: FileLikeObject, filter: any, options: any, msg: string }
  > = new EventEmitter();

  @Output() onResponse: EventEmitter<any> = new EventEmitter();
  @Output() onCompleteAll: EventEmitter<any> = new EventEmitter();
  @Output() onCompleteItem: EventEmitter<any> = new EventEmitter();
  @Output() onAfterAddingFile: EventEmitter<FileItem> = new EventEmitter();
  @Output() onErrorItem: EventEmitter<{ item: FileItem, response: string, status: number, headers: ParsedResponseHeaders, uploader: FileUploader }> = new EventEmitter();
  hasDropzoneOver: boolean = false;

  uploader: FileUploader;
  constructor() { }

  ngOnInit() {
    this.generateUploader();
  }

  ngOnDestroy(): void {
    this.uploader.response.unsubscribe();
    //this.uploader.destroy();
    this.uploader = null;
  }

  generateUploader() {
    this.uploader = new FileUploader({
      url: this.url,
      //disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      autoUpload: this.autoUpload,
      allowedFileType: this.allowedFileTypes || undefined,
      allowedMimeType: this.allowedMimeTypes || undefined,
      maxFileSize: this.maxFileSize
      // formatDataFunctionIsAsync: true,
      // formatDataFunction: async (item) => {
      //   return new Promise((resolve, reject) => {
      //     resolve({
      //       name: item._file.name,
      //       length: item._file.size,
      //       contentType: item._file.type,
      //       date: new Date(),
      //     });
      //   });
      // },
    });
    // this.uploader.onWhenAddingFileFailed = (item) => {
    //   this.onAddingFileFailed.emit(item);
    // };
    this.uploader.onCompleteAll = () => {
      this.onCompleteAll.emit({ uploader: this.uploader });

    }

    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      this.onAfterAddingFile.emit(fileItem);
      if (this.selectDir) {
        this.selectDir.nativeElement.value = "";
      }
      return { fileItem };
    }

    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (status === 200) {
        this.onCompleteItem.emit({ uploader: this.uploader, item, response, status, headers });
      }
    }

    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      let msg = "";
      if (filter.name === "fileSize") {
        let uploadedFileName = item.name;
        msg = `Your uploaded file ${uploadedFileName} was exceed the maximum size limit of ${friendlyMemorySize(this.maxFileSize)}.`;
      } else if (filter.name === "mimeType" || filter.name === "fileType") {
        let allowedFileType = (options.allowedFileType || options.allowedMimeType).join(','), uploadedFileName = item.name;
        msg = `The type of uploaded file {${uploadedFileName}} is not supported, the allowed types are: ${allowedFileType}`;
      }
      if (this.selectDir) {
        this.selectDir.nativeElement.value = "";
      }
      this.onAddingFileFailed.emit({ item, filter, options, msg });

    };

    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {

      this.onErrorItem.emit({ item, response, status, headers, uploader: this.uploader });
    }

    //.response.subscribe(r => this.onResponse.emit({ response: r, uploader: this.uploader }));
  }

  onFileOver(e) {
    this.hasDropzoneOver = e;

  }
}
